import useWindowSize from '@/hooks/useWindowSize'
import { useMapStore } from '@/stores/mapStore'
import React from 'react'
import styled from 'styled-components'
import MinusIcon from '../icons/MinusIcon'
import PlusIcon from '../icons/PlusIcon'
import AddBookingButton from '../ui/button/AddBookingButton'
import DateSelector from './AppBar/booking-filter/DataSelector'

const Controls: React.FC = () => {
    const { width, height } = useWindowSize()
    const stage = useMapStore(state => state.stage)

    const scaleRelativeToPoint = (point: { x: number; y: number }, increaseScale: boolean) => {
        const scaleBy = 1.25
        const oldScale = stage.scaleX()
        
        const mousePointTo = {
            x: point.x / oldScale - stage.x() / oldScale,
            y: point.y / oldScale - stage.y() / oldScale
        }

        const newScale = increaseScale ? oldScale * scaleBy : oldScale / scaleBy
        const x = (point.x / newScale - mousePointTo.x) * newScale
        const y = (point.y / newScale - mousePointTo.y) * newScale

        stage.scale({ x: newScale, y: newScale })
        stage.position({ x, y })
        stage.batchDraw()
    }

    return (
        <ControlsContainer>
            <ControlsWrapper style={{ '--width': '42px', '--height': '84px' } as React.CSSProperties}>
                <ControlButton onClick={() => scaleRelativeToPoint({ x: width / 2, y: height / 2 }, true)}>
                    <PlusIcon color="#2C2C2C" />
                </ControlButton>
                <ControlButton onClick={() => scaleRelativeToPoint({ x: width / 2, y: height / 2 }, false)}>
                    <MinusIcon color="#2C2C2C" />
                </ControlButton>
            </ControlsWrapper>
            
            <DateSelector />

            <AddBookingButton fullWidth label='Создать бронь'/>

        </ControlsContainer>

    )
}

export default Controls

const ControlsContainer = styled.div`
  z-index: 1000;
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
  padding: 16px 0;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }

  @media (max-width: 1024px) {
    bottom: 75px;
  }
`

const ControlsWrapper = styled.div`
    width: var(--width, 42px);
    height: var(--height, 84px);
    overflow: hidden;
    border-radius: 9999px;
    display: flex;
    flex-direction: column;
    background-color: #ffffffff;
    box-shadow: 1px 1px 20px rgba(95, 119, 153, 0.1);
`

const ControlButton = styled.div`
    font-size: 16px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2C2C2C;
    transition: background-color 0.3s ease-out, transform 0.2s;

    cursor: pointer;

    @media (any-hover: hover) {
        &:hover {
            background-color: #f6d1d6;
        }
    }

    &:active {
        transform: scale(0.8);
    }

    &:not(:last-child) {
        margin-bottom: 0; // margin теперь не нужен, т.к. кнопки flex-grow
    }
`
